// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1c79a916","453":"d9a1bfd8","455":"1dd94296","977":"76c19714"}[chunkId] + ".chunk.js";
};